import {
  DEFAULT_TEAMWORK_COMMERCE_RETURN_PURPOSE_TEXT_FALLBACK,
  DEFAULT_TEAMWORK_COMMERCE_RETURN_PURPOSE_TEXT_SOURCE,
  TeamworkCommerceProcessingSettingsSchema,
  TeamworkCommerceReturnPurposeTextSource,
} from "@redotech/redo-integrations-definitions-common/integration/teamwork-commerce";
import * as z from "zod";
import { defineIntegrationSettings } from "../define-settings";

const optionalText = z
  .string()
  .nullish()
  .transform((value) => value?.trim() || undefined);

const enabledByDefault = z
  .boolean()
  .nullish()
  .transform((value) => value ?? true);

function storedObject<Shape extends z.ZodRawShape>(shape: Shape) {
  return z.preprocess((value) => value ?? {}, z.object(shape));
}

const importReceiptSettings = storedObject({
  enabled: enabledByDefault,
  excludeOriginalReceiptNumForGreenReturns: enabledByDefault,
  fillFromLocationId: optionalText,
  globalCharges: storedObject({
    exchangeAdjustmentChargeId: optionalText,
    exchangeAdjustmentMemo: optionalText,
    shippingChargeId: optionalText,
  }),
  importReceiptLocationId: optionalText,
  items: storedObject({
    greenReturnItemSku: optionalText,
    returnPurposeTextFallback: z
      .string()
      .nullish()
      .transform(
        (value) =>
          value?.trim() ||
          DEFAULT_TEAMWORK_COMMERCE_RETURN_PURPOSE_TEXT_FALLBACK,
      ),
    returnPurposeTextSource: z
      .enum(TeamworkCommerceReturnPurposeTextSource)
      .nullish()
      .transform(
        (value) =>
          value ?? DEFAULT_TEAMWORK_COMMERCE_RETURN_PURPOSE_TEXT_SOURCE,
      ),
  }),
});

export const teamworkCommerceSettings = defineIntegrationSettings({
  fields: {
    baseUrl: z.string().trim().min(1, "Base URL is required"),
    processingSettings: TeamworkCommerceProcessingSettingsSchema.nullish(),
    importReceiptSettings,
  },
  secrets: { apiKey: z.string().trim().min(1, "API key is required") },
  connectOnly: {},
  computed: {},
});
